import type { ReactNode } from "react";
import {
  Card,
  CardContent,
  CardLink,
  Heading,
  Stack,
  Text,
} from "@generalapplications/ui";

export type SummaryCardProps = {
  title: string;
  summary: string;
  /** Above the title: a lifecycle chip. */
  eyebrow?: ReactNode;
  /** The record's page; without one the card is a name, not a link. */
  href?: string;
};

/** The common landing-page record card: a title and its one-paragraph summary. */
export function SummaryCard({
  title,
  summary,
  eyebrow,
  href,
}: SummaryCardProps) {
  return (
    <Card radius="xxl" padding="lg" height="full" interactive={Boolean(href)}>
      <CardContent>
        <Stack gap="md" align="start">
          {eyebrow}
          <Heading level={2} size="lg">
            {href ? <CardLink href={href}>{title}</CardLink> : title}
          </Heading>
          <Text leading="relaxed">{summary}</Text>
        </Stack>
      </CardContent>
    </Card>
  );
}
